'use client';

import '@mantine/carousel/styles.css';

import { Carousel } from '@mantine/carousel';
import { Container, Space, Text } from '@mantine/core';
import QuoteBlock from '../travelStyleComponent/quoteBlock/QuoteBlock';
import { Title } from '../../Title/Title';

type TestimonialItem = {
  text?: string;
  quote?: string;
  content?: string;
  author?: string;
  name?: string;
  backgroundImage?: string;
  fontSize?: string;
  fontFamily?: string;
  maxWidth?: string;
  decoration?: boolean;
  animationDelay?: string;
  animationDirection?: 'up' | 'down' | 'left' | 'right';
  threshold?: number;
  variant?: 'classic' | 'testimonial';
  theme?: 'light' | 'dark';
};

export function TestimonialsCarousel({
  title,
  subtitle,
  testimonials,
  theme,
}: {
  title?: string;
  subtitle?: string;
  testimonials?: TestimonialItem[];
  theme?: 'light' | 'dark';
}) {
  const items = (testimonials ?? []).filter(Boolean);

  if (items.length === 0) return null;

  return (
    <section>
      <Container>
        {title ? <Title title={title} /> : null}
        {subtitle ? (
          <>
            <Text c="dimmed" ta="center">
              {subtitle}
            </Text>
            <Space h="lg" />
          </>
        ) : (
          <Space h="lg" />
        )}
        <Carousel
          slideSize="100%"
          slideGap="xl"
          align="start"
          slidesToScroll={1}
          withIndicators
          previousControlProps={{ 'aria-label': 'Previous testimonial' }}
          nextControlProps={{ 'aria-label': 'Next testimonial' }}
        >
          {items.map((item, index) => {
            const text = item.text ?? item.quote ?? item.content ?? '';
            if (!text) return null;

            return (
              <Carousel.Slide key={`${item.author ?? item.name ?? 'testimonial'}-${index}`}>
                <QuoteBlock
                  text={text}
                  author={item.author ?? item.name}
                  fontSize={item.fontSize}
                  fontFamily={item.fontFamily}
                  maxWidth={item.maxWidth}
                  decoration={item.decoration}
                  animationDelay={item.animationDelay}
                  animationDirection={item.animationDirection}
                  threshold={item.threshold}
                  variant={item.variant ?? 'testimonial'}
                  theme={item.theme ?? theme ?? 'light'}
                />
              </Carousel.Slide>
            );
          })}
        </Carousel>
      </Container>
    </section>
  );
}
